import { Box, Button, styled } from '@/theme/index';

export const CrownImgContainer = styled(Box)(({ theme }) => ({
  width: 50,
  height: 50,
  marginBottom: theme.spacing(2),
  background: 'center / contain no-repeat',
}));

export const BannerImgContainer = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
  background: 'center / contain no-repeat',
  [theme.breakpoints.up('sm')]: {
    margin: `0 0 ${theme.spacing(2)} 0 `,
    width: 650,
    height: 134,
  },
  [theme.breakpoints.up('md')]: {
    width: 738,
    height: 134,
  },
}));

export const BannerImgContainerMob = styled(Box)(({ theme }) => ({
  width: 268,
  height: 134,
  background: 'center / contain no-repeat',
  [theme.breakpoints.down(340)]: {
    width: 230,
  },
}));

export const IconSearchContainer = styled(Box)(({ theme }) => ({
  width: 44,
  height: 44,
  minWidth: 44,
  minHeight: 44,
  marginRight: theme.spacing(2),
  background: 'center / contain no-repeat',
  [theme.breakpoints.up('sm')]: {
    margin: `0 ${theme.spacing(2)} 0 0 `,
  },
}));

export const LinkButton = styled(Button)({
  textDecoration: 'underline',
  ':hover': { textDecoration: 'underline', backgroundColor: 'inherit' },
  padding: 0,
  lineHeight: 1.2,
  verticalAlign: 'baseline',
});
